import { host } from '../config';

export default function getEntities(endpoint, data = {}, isOneRegister = false) {
    console.log(endpoint);
    return fetch(`${host}${endpoint}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data)
        })
        .then(res => res.json())
        .then(arr => {
            console.log(arr)
            if(!isOneRegister) if(!Array.isArray(arr)) return [];
            return arr;
        }).catch(ex => { console.log('ERROR', ex); return [] })
}